import StandardImageList from "./Gallery";

export default StandardImageList;